import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '40px 20px'
    }}>
      <div style={{
        maxWidth: '800px',
        margin: '0 auto',
        background: 'white',
        borderRadius: '16px',
        padding: '40px',
        boxShadow: '0 10px 40px rgba(0,0,0,0.2)'
      }}>
        <Link to="/" style={{ 
          color: '#667eea', 
          textDecoration: 'none',
          display: 'inline-flex',
          alignItems: 'center',
          marginBottom: '20px',
          fontSize: '14px'
        }}>
          ← Back to Home
        </Link>
        
        <h1 style={{ 
          color: '#1a1a2e', 
          marginBottom: '10px',
          fontSize: '2.5rem'
        }}>
          Privacy Policy
        </h1>
        
        <p style={{ color: '#666', marginBottom: '30px' }}>
          Last Updated: October 20, 2026
        </p>

        {/* Section 1 - Introduction */}
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: '#333', fontSize: '1.5rem', marginBottom: '15px' }}>
            1. Introduction
          </h2>
          <p style={{ color: '#555', lineHeight: '1.8' }}>
            Thornbee LLC ("we," "our," or "us") operates the FreeHappyOne Platform at FreeHappyOne.com ("Platform"). This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our Platform and its integrated AI coaching applications.
          </p>
          <p style={{ color: '#555', lineHeight: '1.8', marginTop: '15px' }}>
            The FHO Platform includes four integrated AI coaches:
          </p>
          <ul style={{ color: '#555', lineHeight: '2', marginLeft: '20px' }}>
            <li><strong>Emit / SAGE</strong> - Biblical and spiritual wisdom coaching</li>
            <li><strong>SAFE</strong> - Mental health support and emotional wellness</li>
            <li><strong>Family Coach</strong> - Parenting, grandparenting, and family relationships</li>
            <li><strong>Mental Performance</strong> - Peak performance coaching (CHAMP/SHIP programs)</li>
          </ul>
        </section>

        {/* Section 2 - Information We Collect */}
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: '#333', fontSize: '1.5rem', marginBottom: '15px' }}>
            2. Information We Collect
          </h2>
          
          <h3 style={{ color: '#444', fontSize: '1.2rem', marginBottom: '10px', marginTop: '20px' }}>
            Account Information
          </h3>
          <p style={{ color: '#555', lineHeight: '1.8' }}>
            When you create an account, we collect:
          </p>
          <ul style={{ color: '#555', lineHeight: '2', marginLeft: '20px' }}>
            <li>Email address</li>
            <li>Name (optional)</li>
            <li>Password (encrypted)</li>
          </ul>

          <h3 style={{ color: '#444', fontSize: '1.2rem', marginBottom: '10px', marginTop: '20px' }}>
            Profile Information by Coach
          </h3>
          <p style={{ color: '#555', lineHeight: '1.8' }}>
            Depending on which coaches you use, we collect:
          </p>
          <ul style={{ color: '#555', lineHeight: '2', marginLeft: '20px' }}>
            <li><strong>Emit / SAGE:</strong> Faith background, spiritual interests, biblical and Source-aligned topics explored</li>
            <li><strong>SAFE:</strong> Preferred name, military/veteran status, branch of service, years of service, discharge status, primary mental health challenges, faith preference, coaching tone preference</li>
            <li><strong>Family Coach:</strong> Family structure, children's names and ages, parenting challenges, relationship goals</li>
            <li><strong>Mental Performance:</strong> Performance domain (athlete, executive, entrepreneur, performer, student, sales, medical), program type (CHAMP or SHIP), sport/industry/role details, years of experience, performance goals and challenges</li>
          </ul>

          <h3 style={{ color: '#444', fontSize: '1.2rem', marginBottom: '10px', marginTop: '20px' }}>
            Conversation Data
          </h3>
          <p style={{ color: '#555', lineHeight: '1.8' }}>
            We collect and store:
          </p>
          <ul style={{ color: '#555', lineHeight: '2', marginLeft: '20px' }}>
            <li>All messages exchanged with AI coaches</li>
            <li>Conversation history for continuity</li>
            <li>Topics and questions discussed</li>
          </ul>

          <h3 style={{ color: '#444', fontSize: '1.2rem', marginBottom: '10px', marginTop: '20px' }}>
            Session and Analytics Data
          </h3>
          <p style={{ color: '#555', lineHeight: '1.8' }}>
            We automatically collect:
          </p>
          <ul style={{ color: '#555', lineHeight: '2', marginLeft: '20px' }}>
            <li>Session timestamps and duration</li>
            <li>Mood ratings (before and after sessions, where provided)</li>
            <li>Feature usage patterns across coaches</li>
            <li>Content relevance metrics (which guidance resonates)</li>
            <li>Device and browser information</li>
          </ul>
        </section>

        {/* Section 3 - Sensitive Information */}
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: '#333', fontSize: '1.5rem', marginBottom: '15px' }}>
            3. Sensitive Information
          </h2>
          <p style={{ color: '#555', lineHeight: '1.8' }}>
            Some information we collect may be considered sensitive, including:
          </p>
          <ul style={{ color: '#555', lineHeight: '2', marginLeft: '20px' }}>
            <li><strong>Mental Health Information:</strong> Emotional challenges, anxiety, stress, and wellness discussions shared with SAFE</li>
            <li><strong>Military/Veteran Status:</strong> Service history, branch, and discharge status</li>
            <li><strong>Religious Beliefs:</strong> Faith preferences and spiritual background</li>
            <li><strong>Family Information:</strong> Details about children, spouse, and family dynamics</li>
          </ul>
          <p style={{ color: '#555', lineHeight: '1.8', marginTop: '15px' }}>
            We treat this information with extra care and use it solely to personalize your coaching experience. We do not sell or share sensitive information with third parties for marketing purposes.
          </p>
        </section>

        {/* Section 4 - Cross-App Data Sharing */}
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: '#333', fontSize: '1.5rem', marginBottom: '15px' }}>
            4. Cross-App Data Sharing Within the Platform
          </h2>
          <div style={{
            background: '#f8f9fa',
            padding: '20px',
            borderRadius: '8px',
            borderLeft: '4px solid #667eea',
            marginBottom: '15px'
          }}>
            <p style={{ color: '#555', lineHeight: '1.8', margin: 0 }}>
              <strong>Important:</strong> The four AI coaches on the FHO Platform share information with each other to provide integrated, holistic guidance. This is a core feature of the Platform.
            </p>
          </div>
          <p style={{ color: '#555', lineHeight: '1.8' }}>
            By using the Platform, you consent to the following cross-app data sharing:
          </p>
          <ul style={{ color: '#555', lineHeight: '2', marginLeft: '20px' }}>
            <li><strong>SAFE reads Mental Performance profile:</strong> To provide context-aware mental health support (e.g., understanding that you're an entrepreneur facing startup stress)</li>
            <li><strong>Family Coach reads other profiles:</strong> To understand your complete family and professional context</li>
            <li><strong>Emit / SAGE reads profile data:</strong> To personalize biblical or spiritual guidance based on your life situation</li>
            <li><strong>Mental Performance reads SAFE profile:</strong> To understand wellness factors affecting performance</li>
          </ul>
          <p style={{ color: '#555', lineHeight: '1.8', marginTop: '15px' }}>
            <strong>Opting Out:</strong> If you do not want cross-app data sharing, contact support@freehappyone.com to request data isolation. Note that some personalization features will be limited.
          </p>
        </section>

        {/* Section 5 - How We Use Your Information */}
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: '#333', fontSize: '1.5rem', marginBottom: '15px' }}>
            5. How We Use Your Information
          </h2>
          <p style={{ color: '#555', lineHeight: '1.8' }}>
            We use your information to:
          </p>
          <ul style={{ color: '#555', lineHeight: '2', marginLeft: '20px' }}>
            <li>Provide personalized AI coaching across all four coaches</li>
            <li>Maintain conversation context and continuity</li>
            <li>Tailor guidance to your specific life circumstances</li>
            <li>Enable cross-app integration for holistic support</li>
            <li>Track your transformation journey and progress</li>
            <li>Process payments and manage subscriptions</li>
            <li>Send important service updates</li>
            <li>Improve our AI coaching quality and develop new features</li>
            <li>Generate anonymized analytics to measure platform effectiveness</li>
          </ul>
        </section>

        {/* Section 6 - AI and Third-Party Services */}
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: '#333', fontSize: '1.5rem', marginBottom: '15px' }}>
            6. AI and Third-Party Services
          </h2>
          <p style={{ color: '#555', lineHeight: '1.8' }}>
            <strong>Anthropic (Claude AI):</strong> All four AI coaches are powered by Anthropic's Claude AI. When you interact with any coach:
          </p>
          <ul style={{ color: '#555', lineHeight: '2', marginLeft: '20px' }}>
            <li>Your messages are sent to Anthropic's API for processing</li>
            <li>Anthropic processes this data according to their privacy policy</li>
            <li>We do not share your personal identity (email, name) with Anthropic</li>
            <li>Profile context is included to personalize responses</li>
            <li>Anthropic does not use your conversations to train their models</li>
          </ul>
          <p style={{ color: '#555', lineHeight: '1.8', marginTop: '15px' }}>
            <strong>Payment Processing:</strong> We use Stripe for payment processing. Your payment information is handled directly by Stripe and never stored on our servers.
          </p>
          <p style={{ color: '#555', lineHeight: '1.8', marginTop: '15px' }}>
            <strong>Hosting:</strong> Our Platform is hosted on DigitalOcean servers located in the United States.
          </p>
        </section>

        {/* Section 7 - Data Storage and Security */}
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: '#333', fontSize: '1.5rem', marginBottom: '15px' }}>
            7. Data Storage and Security
          </h2>
          <p style={{ color: '#555', lineHeight: '1.8' }}>
            We implement industry-standard security measures including:
          </p>
          <ul style={{ color: '#555', lineHeight: '2', marginLeft: '20px' }}>
            <li>SSL/TLS encryption for all data in transit</li>
            <li>Encrypted password storage (bcrypt hashing)</li>
            <li>Secure cloud hosting with regular security updates</li>
            <li>Access controls limiting employee data access</li>
            <li>Regular security monitoring and vulnerability assessments</li>
          </ul>
          <p style={{ color: '#555', lineHeight: '1.8', marginTop: '15px' }}>
            Your data is stored on secure servers located in the United States.
          </p>
        </section>

        {/* Section 8 - Data Retention */}
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: '#333', fontSize: '1.5rem', marginBottom: '15px' }}>
            8. Data Retention
          </h2>
          <p style={{ color: '#555', lineHeight: '1.8' }}>
            We retain your data as follows:
          </p>
          <ul style={{ color: '#555', lineHeight: '2', marginLeft: '20px' }}>
            <li><strong>Conversations:</strong> Kept until you delete them, so your coach can remember what you have shared. You can delete any conversation at any time from Conversation History in each app.</li>
            <li><strong>Your profile, check-ins and progress:</strong> Kept while your account is open, and deleted when your account is deleted.</li>
            <li><strong>Deleting your account:</strong> Choose "Delete my account" in the app menu. Your account, conversations, profile, check-ins and progress are deleted right away. Copies in our backups are replaced within 35 days. We keep only a record that a deletion took place, without your email address.</li>
            <li><strong>Inactive accounts:</strong> Accounts with no activity for 2 years are deleted, along with everything in them.</li>
            <li><strong>Anonymized data:</strong> Information that cannot identify you may be retained for research and to improve the service</li>
            <li><strong>Payment records:</strong> Retained as required by law (typically 7 years)</li>
          </ul>
        </section>

        {/* Section 9 - Your Rights */}
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: '#333', fontSize: '1.5rem', marginBottom: '15px' }}>
            9. Your Rights
          </h2>
          <p style={{ color: '#555', lineHeight: '1.8' }}>
            You have the right to:
          </p>
          <ul style={{ color: '#555', lineHeight: '2', marginLeft: '20px' }}>
            <li><strong>Access:</strong> Request a copy of all personal data we hold about you</li>
            <li><strong>Correction:</strong> Update inaccurate information in your profiles</li>
            <li><strong>Deletion:</strong> Request deletion of your account and all associated data</li>
            <li><strong>Export:</strong> Download your conversation history and profile data</li>
            <li><strong>Restrict Processing:</strong> Request limits on how we use your data</li>
            <li><strong>Data Isolation:</strong> Opt out of cross-app data sharing</li>
            <li><strong>Opt-out:</strong> Unsubscribe from marketing communications</li>
          </ul>
          <p style={{ color: '#555', lineHeight: '1.8', marginTop: '15px' }}>
            To exercise these rights, contact us at support@freehappyone.com. We will respond within 30 days.
          </p>
        </section>

        {/* Section 10 - Children and Minors */}
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: '#333', fontSize: '1.5rem', marginBottom: '15px' }}>
            10. Children and Minors
          </h2>
          <p style={{ color: '#555', lineHeight: '1.8' }}>
            The FHO Platform is intended for users 14 years of age and older. We do not knowingly collect personal information from anyone under 14.
          </p>
          <p style={{ color: '#555', lineHeight: '1.8', marginTop: '15px' }}>
            <strong>Family Coach Exception:</strong> Adult users may provide information <em>about</em> their children (such as names and ages) for the purpose of receiving parenting guidance. This information about children is:
          </p>
          <ul style={{ color: '#555', lineHeight: '2', marginLeft: '20px' }}>
            <li>Provided by and controlled by the adult user</li>
            <li>Used solely to personalize parenting guidance</li>
            <li>Never shared with third parties</li>
            <li>Deleted upon account deletion or user request</li>
          </ul>
          <p style={{ color: '#555', lineHeight: '1.8', marginTop: '15px' }}>
            If you believe we have inadvertently collected information from a minor, please contact us immediately.
          </p>
        </section>

        {/* Section 11 - Cookies */}
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: '#333', fontSize: '1.5rem', marginBottom: '15px' }}>
            11. Cookies and Tracking
          </h2>
          <p style={{ color: '#555', lineHeight: '1.8' }}>
            We use essential cookies to:
          </p>
          <ul style={{ color: '#555', lineHeight: '2', marginLeft: '20px' }}>
            <li>Maintain your login session</li>
            <li>Remember your preferences and settings</li>
            <li>Ensure security of your account</li>
            <li>Track which coach you're interacting with</li>
          </ul>
          <p style={{ color: '#555', lineHeight: '1.8', marginTop: '15px' }}>
            We do not use advertising cookies or sell data to third-party advertisers.
          </p>
        </section>

        {/* Section 12 - Research and Analytics */}
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: '#333', fontSize: '1.5rem', marginBottom: '15px' }}>
            12. Research and Platform Improvement
          </h2>
          <p style={{ color: '#555', lineHeight: '1.8' }}>
            We may use anonymized and aggregated data to:
          </p>
          <ul style={{ color: '#555', lineHeight: '2', marginLeft: '20px' }}>
            <li>Measure the effectiveness of our coaching approaches</li>
            <li>Understand patterns in user transformation journeys</li>
            <li>Improve our AI coaching quality</li>
            <li>Publish research on wellness and personal development (anonymized only)</li>
          </ul>
          <p style={{ color: '#555', lineHeight: '1.8', marginTop: '15px' }}>
            Anonymized data cannot be traced back to you individually.
          </p>
        </section>

        {/* Section 13 - California Residents */}
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: '#333', fontSize: '1.5rem', marginBottom: '15px' }}>
            13. California Privacy Rights (CCPA)
          </h2>
          <p style={{ color: '#555', lineHeight: '1.8' }}>
            California residents have additional rights under the California Consumer Privacy Act:
          </p>
          <ul style={{ color: '#555', lineHeight: '2', marginLeft: '20px' }}>
            <li><strong>Right to Know:</strong> What personal information we collect and how we use it</li>
            <li><strong>Right to Delete:</strong> Request deletion of your personal information</li>
            <li><strong>Right to Opt-Out:</strong> We do not sell personal information</li>
            <li><strong>Right to Non-Discrimination:</strong> We will not discriminate against you for exercising your rights</li>
          </ul>
          <p style={{ color: '#555', lineHeight: '1.8', marginTop: '15px' }}>
            To exercise these rights, contact support@freehappyone.com or call our privacy line.
          </p>
        </section>

        {/* Section 14 - European Privacy Rights (GDPR) */}
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: '#333', fontSize: '1.5rem', marginBottom: '15px' }}>
            14. European Privacy Rights (GDPR)
          </h2>
          <p style={{ color: '#555', lineHeight: '1.8' }}>
            If you are located in the European Economic Area (EEA), United Kingdom, or Switzerland, you have additional rights under the General Data Protection Regulation (GDPR):
          </p>
          <ul style={{ color: '#555', lineHeight: '2', marginLeft: '20px' }}>
            <li><strong>Right of Access:</strong> Request a copy of your personal data</li>
            <li><strong>Right to Rectification:</strong> Request correction of inaccurate data</li>
            <li><strong>Right to Erasure:</strong> Request deletion of your personal data ("right to be forgotten")</li>
            <li><strong>Right to Restrict Processing:</strong> Request limitation of how we use your data</li>
            <li><strong>Right to Data Portability:</strong> Receive your data in a structured, machine-readable format</li>
            <li><strong>Right to Object:</strong> Object to processing based on legitimate interests</li>
            <li><strong>Right to Withdraw Consent:</strong> Withdraw consent at any time where processing is based on consent</li>
          </ul>
          <p style={{ color: '#555', lineHeight: '1.8', marginTop: '15px' }}>
            <strong>Legal Basis for Processing:</strong> We process your personal data based on:
          </p>
          <ul style={{ color: '#555', lineHeight: '2', marginLeft: '20px' }}>
            <li>Your consent (which you can withdraw at any time)</li>
            <li>Performance of our contract with you</li>
            <li>Our legitimate business interests</li>
            <li>Compliance with legal obligations</li>
          </ul>
          <p style={{ color: '#555', lineHeight: '1.8', marginTop: '15px' }}>
            <strong>International Data Transfers:</strong> Your data may be transferred to and processed in the United States. We ensure appropriate safeguards are in place for such transfers in compliance with GDPR requirements.
          </p>
          <p style={{ color: '#555', lineHeight: '1.8', marginTop: '15px' }}>
            To exercise your GDPR rights, contact us at support@freehappyone.com. You also have the right to lodge a complaint with your local data protection authority.
          </p>
        </section>
        {/* Section 15 - Changes */}
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: '#333', fontSize: '1.5rem', marginBottom: '15px' }}>
            15. Changes to This Policy
          </h2>
          <p style={{ color: '#555', lineHeight: '1.8' }}>
            We may update this Privacy Policy as our Platform evolves. We will notify you of significant changes via:
          </p>
          <ul style={{ color: '#555', lineHeight: '2', marginLeft: '20px' }}>
            <li>Email notification to your registered address</li>
            <li>Prominent notice on the Platform</li>
            <li>Updated "Last Updated" date at the top of this policy</li>
          </ul>
          <p style={{ color: '#555', lineHeight: '1.8', marginTop: '15px' }}>
            Your continued use after changes constitutes acceptance of the updated policy.
          </p>
        </section>

        {/* Section 16 - Contact */}
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: '#333', fontSize: '1.5rem', marginBottom: '15px' }}>
            16. Contact Us
          </h2>
          <p style={{ color: '#555', lineHeight: '1.8' }}>
            For privacy-related questions, concerns, or to exercise your rights:
          </p>
          <div style={{
            background: '#f8f9fa',
            padding: '20px',
            borderRadius: '8px',
            marginTop: '15px'
          }}>
            <p style={{ color: '#333', lineHeight: '1.8', margin: 0 }}>
              <strong>Thornbee LLC</strong><br />
              Email: support@freehappyone.com<br /><br />
              <strong>Mailing Address:</strong><br />
              Thornbee LLC<br />
              1001 Wade Ave Suite 327<br />
              Raleigh, NC 27605<br />
              United States
            </p>
          </div>
        </section>

        <div style={{ 
          marginTop: '40px', 
          paddingTop: '20px', 
          borderTop: '1px solid #eee',
          textAlign: 'center'
        }}>
          <p style={{ color: '#888', fontSize: '14px', marginBottom: '20px' }}>
            © 2026 Thornbee LLC. All rights reserved.
          </p>
          <Link to="/" style={{
            display: 'inline-block',
            padding: '12px 30px',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            borderRadius: '8px',
            textDecoration: 'none',
            fontWeight: '600'
          }}>
            Return to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
